import React, { createContext, useState, useEffect, useContext } from 'react';
import { getServices, getCompanyInfo } from '../services/api';
import { companyInfo as defaultCompanyInfo, services as defaultServices } from '../mockData';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [companyInfo, setCompanyInfo] = useState(defaultCompanyInfo);
  const [services, setServices] = useState(defaultServices);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [companyInfoData, servicesData] = await Promise.all([
          getCompanyInfo(),
          getServices()
        ]);
        
        setCompanyInfo(companyInfoData);
        setServices(servicesData);
      } catch (error) {
        console.error("Error fetching global data:", error);
        // Keep using default mock data on error
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const value = {
    companyInfo,
    services,
    loading
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};
